export const STRING_ACCESS_TOKEN_TUTTIENGLISH = "accessTokenTuttiEnglish";

export const STRING_SIDEBAR_EXPANDED_TUTTIENGLISH = "SIDEBAR_EXPANDED_TUTTIENG";

export const STRING_LANGUAGE_TUTTIENGLISH = "language";

export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const URL = "url";
export const CHECK = "check";
export const UBICACION_GPS = "ubicacion_gps";
export const COLOR = "color";
export const ACCIONES = "acciones";
export const CORREOS = "correos";